{
  "Account creation request sent": "Accountverzoek verzonden",
  "Add address...": "Voer adres in...",
  "Add chamber of commerce number...": "Voer KvK-nummer in...",
  "Add city...": "Voer plaats in...",
  "Add client name...": "Voer klantnaam in...",
  "Add company name...": "Voer bedrijfsnaam in...",
  "Add email...": "Voer e-mail in...",
  "Add postal code...": "Voer postcode in...",
  "Add tax number...": "Voer BTW-nummer in...",
  "Add work address...": "Voer werkadres in...",
  "Add work city...": "Voer werkplaats in...",
  "Add work location...": "Voer werklocatie in...",
  "Add work postal code...": "Voer werkpostcode in...",
  "Address": "Adres",
  "All products": "Alle producten",
  "An error occurred while ordering the products": "Er is een fout opgetreden bij het bestellen van de producten",
  "An error occurred while sending the account request": "Er is een fout opgetreden bij het verzenden van het accountverzoek",
  "Are you sure you want to confirm this order?": "Weet je zeker dat je deze bestelling wilt bevestigen?",
  "Cancel": "Annuleren",
  "Capacity": "Capaciteit",
  "Categories": "Categorieën",
  "Chamber of commerce number": "KvK-nummer",
  "Change Category": "Categorie wijzigen",
  "Change Products": "Producten wijzigen",
  "Change Search Term": "Zoekopdracht wijzigen",
  "City": "Plaats",
  "Client name": "Klantnaam",
  "Close": "Sluiten",
  "Company name": "Bedrijfsnaam",
  "Save": "Opslaan",
  "Confirm": "Bestellen",
  "Confirm order": "Bestelling bevestigen",
  "Delivery": "Levering (prijs in overleg)",
  "Delivery or pickup": "Levering of ophalen",
  "Delivery or pickup?": "Levering of ophalen?",
  "Description": "Omschrijving",
  "discount": "korting",
  "Don't have an account?": "Nog geen account?",
  "Download PDF": "Download PDF",
  "Email": "E-mail",
  "Enter password...": "Voer wachtwoord in...",
  "Enter username...": "Voer gebruikersnaam in...",
  "Good afternoon": "Goedemiddag",
  "Good evening": "Goedenavond",
  "Good morning": "Goedemorgen",
  "Height": "Hoogte",
  "ID": "ID",
  "Length": "Lengte",
  "Login": "Inloggen",
  "Welcome!": "Welkom!",
  "Log in here with your account to place an order.": "Log hier in met je account om een bestelling door te geven.",
  "To request a quote, go back to our homepage and use the REQUEST QUOTE button.": "Wilt u een <strong>offerte aanvragen</strong>? Ga dan terug naar onze homepagina en klik op <strong>OFFERTE AANVRAGEN</strong>. Daar heb je <strong>geen account</strong> voor nodig.",
  "Next": "Volgende",
  "No products found": "Geen producten gevonden",
  "One-time Costs": "Eenmalige kosten",
  "Order": "Bestelling",
  "Order Date": "Besteldatum",
  "Order Details": "Bestelgegevens",
  "Order has been made successfully": "Je bestelling is succesvol geplaatst",
  "Password": "Wachtwoord",
  "Pickup": "Ophalen",
  "Please provide all necessary data.": "Voer a.u.b. alle benodigde gegevens in.",
  "Postal code": "Postcode",
  "Product details": "Productdetails",
  "Products": "Artikelen",
  "Quantity": "Aantal",
  "Rental": "Verhuur",
  "Request a Account": "Vraag een account aan",
  "Request access": "Vraag toegang aan",
  "Sale": "Verkoop",
  "Search": "Zoeken",
  "Search by product id or description": "Zoek op artikelnummer of omschrijving",
  "Search results for": "Zoekresultaten voor",
  "Send": "Verzenden",
  "Sign in to your account to continue.": "Log in op je account om door te gaan.",
  "Subtotal": "Subtotaal",
  "Tax number": "BTW-nummer",
  "Thickness": "Dikte",
  "Total": "Totaal",
  "Total EUR excl. VAT": "Totaal EUR excl. btw",
  "Total EUR incl. VAT": "Totaal EUR incl. btw",
  "Username": "Gebruikersnaam",
  "Username or password incorrect!": "Gebruikersnaam of wachtwoord onjuist!",
  "VAT": "btw",
  "Weekly Cost": "Kosten per week",
  "Weight": "Gewicht",
  "Width": "Breedte",
  "Work address": "Werkadres",
  "Work city": "Werkplaats",
  "Work location": "Werklocatie",
  "Work postal code": "Werkpostcode",
  "Choose Activity": "Kies activiteit",
  "Order Picking": "Order picken",
  "Order Checking": "Order controles",
  "Order Returning": "Order retouren",
  "Orders to Pick": "Pickorders",
  "Orders to Check": "Controleorders",
  "Orders to Return": "Retourorders",
  "Pick Order": "Pickorder",
  "Return Order": "Retourorder",
  "Check Order": "Controleorder",
  "Ordered": "Besteld",
  "Picked": "Gepickt",
  "Delivered": "Geleverd",
  "Returned": "Retour",
  "Shortcoming": "Manco",
  "Damaged": "Schade",
  "No order lines found": "Geen orderregels gevonden",
  "Back": "Terug",
  "Yes": "Ja",
  "No": "Nee",
  "No orders available.": "Geen orders beschikbaar.",
  "Did you checked everything?": "Heb je alles gecontroleerd?",
  "Click for image": "Klik voor afbeelding",
  "Empty cart": "Winkelwagen leeg",
  "Received": "Geretourneerd",
  "Missing": "Resterend",
  "Cancel order": "Bestelling annuleren",
  "Are you sure you want to cancel this order and clear selected products?": "Weet je zeker dat je het bestellen wilt annuleren en je productselectie wilt wissen?",
  "Incomplete Order Input": "Incomplete  order invoer",
  "Some orders are still pending. Would you like to save your current input and resume later?": "Sommige orders zijn nog in behandeling. Wil je je huidige invoer opslaan en later hervatten?",
  "Input not as expected": "Afwijkende invoer",
  "Are you sure you want to make the picked quantities definitive?": "Weet je zeker dat je de gepickte aantallen definitief wilt maken?",
  "Is the compartment empty?": "Is het vak leeg?"
}
